<script setup lang="ts">
const props = defineProps<{
  modelValue?: boolean
  persistent?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [val: boolean]
}>()

function close() {
  if (!props.persistent) emit('update:modelValue', false)
}
</script>

<template>
  <Teleport to="body">
    <Transition name="m-bottom-sheet">
      <div v-if="modelValue" class="m-bottom-sheet__overlay" @click.self="close">
        <div class="m-bottom-sheet__content">
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.m-bottom-sheet__overlay {
  position: fixed;
  inset: 0;
  z-index: var(--m-z-modal);
  display: flex;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.5);
}

.m-bottom-sheet__content {
  width: 100%;
  background: var(--m-surface);
  border-radius: var(--m-radius-lg) var(--m-radius-lg) 0 0;
  max-height: 80vh;
  overflow-y: auto;
}

.m-bottom-sheet-enter-active,
.m-bottom-sheet-leave-active { transition: opacity var(--m-transition-slow); }
.m-bottom-sheet-enter-active .m-bottom-sheet__content,
.m-bottom-sheet-leave-active .m-bottom-sheet__content { transition: transform var(--m-transition-slow); }

.m-bottom-sheet-enter-from,
.m-bottom-sheet-leave-to { opacity: 0; }
.m-bottom-sheet-enter-from .m-bottom-sheet__content,
.m-bottom-sheet-leave-to .m-bottom-sheet__content { transform: translateY(100%); }
</style>
